<template>
  <div class="modal" :class="{ 'is-active': visible && jobs.length > 0 }">
    <div class="modal-background" @click="$emit('toggle')"></div>
    <div class="modal-card failed-jobs-modal">
      <header class="modal-card-head">
        <div>
          <p class="modal-card-title">{{ $t('failed-ai-jobs') }}</p>
          <p class="failed-jobs-summary">{{ $tc('failed-jobs-count', jobs.length, { count: jobs.length }) }}</p>
        </div>
        <button class="delete" aria-label="close" @click="$emit('toggle')"></button>
      </header>
      <section class="modal-card-body">
        <div v-for="job in jobs" :key="job.sessionId" class="failed-job">
          <div class="failed-job-content">
            <i class="fas fa-times-circle has-text-danger failed-job-icon"></i>
            <div class="failed-job-body">
              <div class="failed-job-header">
                <span class="has-text-weight-bold is-size-6">{{ job.runnerName }}</span>
                <span class="is-size-7 failed-job-time">{{ job.time }}</span>
              </div>
              <div class="is-size-7 failed-job-message">
                {{ job.errorMessage }}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'algorithm-failed-jobs-panel',
  props: {
    jobs: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../assets/styles/dark-variables';

.failed-jobs-modal {
  width: 38rem;
  max-width: calc(100vw - 2rem);
}

.failed-job {
  margin-bottom: 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.failed-job:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: 0;
}

.failed-job-content {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.failed-job-icon {
  margin-top: 4px;
}

.failed-job-body {
  flex-grow: 1;
}

.failed-job-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
}

.failed-job-message {
  margin-top: 0.25rem;
  line-height: 1.4;
  color: $dark-text-secondary;
  word-break: break-word;
}

.failed-job-time,
.failed-jobs-summary {
  color: $dark-text-secondary;
}

.failed-jobs-summary {
  margin-top: 0.15rem;
  font-size: 0.75rem;
}
</style>
